export default {"src":"/_next/static/media/ic_new_wallet.c207d4ad.svg","height":24,"width":22,"blurWidth":0,"blurHeight":0};